import { useTranslation } from 'next-i18next';
import { GetStaticProps } from 'next';

import { EmployerSecondaryLayout } from '../../../layouts';
import { getServerTranslations } from '../../../get-server-side-translations';
import CollaboratorsPageContent from '../../../components/collaborators/collaborators-page-content';

function CollaboratorsPage() {
  const { t } = useTranslation('collaborators-page');

  return (
    <EmployerSecondaryLayout pageTitle={t('collaborators')}>
      <CollaboratorsPageContent />
    </EmployerSecondaryLayout>
  );
}
export default CollaboratorsPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await getServerTranslations(locale, ['common', 'collaborators-page']);
  return {
    props: {
      ...translation,
    },
  };
};
